import { AuthenticationRepository } from "@src/cloud-connect/node-manager/authentication/authentication-repository";
import { AuthenticationHeadersBuilder } from "./authentication-headers-builder";

/**
 * Will eventually be replace by context dependency injection
 */
export const buildAuthenticationHeaders = () => {
  return new AuthenticationHeadersBuilder(
    new AuthenticationRepository(),
  ).build();
};
